import comSpSkeleton from "../../../../engines/components/comSpSkeleton";
import gameConfig from "../../../../engines/configs/gameConfig";
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import NormalGameManager from "../../manager/NormalGameManager";
import LotteryResult from "./LotteryResult";

const {ccclass, property} = cc._decorator;

@ccclass
export default class LotteryMachine extends cc.Component {

    @property({type:cc.Node,displayName:"号码按钮Layout"})
    numLayout:cc.Node = null;

    @property({type:cc.Node,displayName:"购买按钮"})
    buyBtn:cc.Node = null;

    @property({type:cc.Node,displayName:"自己选择layout"})
    selectLayout:cc.Node = null;

    @property({type:comSpSkeleton,displayName:"摇奖机动画"})
    machineAni:comSpSkeleton = null;

    @property({type:comSpSkeleton,displayName:"球动画"})
    ballAni:comSpSkeleton = null;

    @property({type:cc.Node,displayName:"球的挂点"})
    ballPoint:cc.Node = null;

    @property({type:cc.Node,displayName:"摇奖的球的layout"})
    lotteryLayout:cc.Node = null;

    @property({type:cc.Node,displayName:"结算节点"})
    resultNode:cc.Node = null;

    pressNums:number[] = [];

    rewardNums:number[] = [];

    isBuy:boolean = false;

    manager:NormalGameManager = null;

    lotteryPrice:number = 30;

    @property({type:cc.Node,displayName:"球节点"})
    ballNode:cc.Node = null;

    start(){
        this.manager = NormalGameManager._instance;

        let pressNums = this.manager.getGameData().lotteryMachineData.meSelectAry;
        let rewadrNums = this.manager.getGameData().lotteryMachineData.winAry;
        if(pressNums && pressNums.length ==5){
            this.isBuy = true;
            this.pressNums = pressNums.concat();
            this.rewardNums = rewadrNums.concat();
        }
        this.updateBtns();
        this.updateSelectLayout();

        if(this.isBuy){
            this.machineAni.playAnimation("animation").start(true);
        }

        this.scheduleOnce(()=>{
            if(this.isBuy && this.manager.getCurrentDay() - this.manager.getGameData().lotteryMachineData.buyDay >0){

                if ( this.manager.getGameData().lotteryFuturePrize
                && this.manager.getGameData().lotteryFuturePrize.triggerDay == this.manager.getCurrentDay() ) {
                    //如果 有漂流瓶 触发的未来特殊 双色球事件
                    let prizeNumArray : number[] = [];
                    for ( let prizeNum of this.manager.getGameData().lotteryFuturePrize.prizeNum ) {
                        prizeNumArray.push( Number( prizeNum ) );
                    }
                    let goldNumArray : number[] = [];
                    for ( let goldNum of this.manager.getGameData().lotteryFuturePrize.goldNum ) {
                        goldNumArray.push( Number( goldNum ) );
                    }
                    this.rewardNums = prizeNumArray;
                    this.manager.getGameData().lotteryMachineData.winAry = prizeNumArray;
                    this.manager.getGameData().lotteryMachineData.goldAry = goldNumArray;
                    this.manager.getGameData().lotteryFuturePrize = null;
                    this.manager.writeGameData();
                }

                // 开奖
                this.openReward();
            }
        },1);

        // this.node.zIndex = 1;
    }

    updateBtns(){
        this.numLayout.children.forEach((n:cc.Node,index:number)=>{
            let nBNode:cc.Node = n.getChildByName("ball_b");
            let nHNode:cc.Node = n.getChildByName("ball_h");
            let nBLb:cc.Label = nBNode.getChildByName("lb").getComponent(cc.Label);
            let nHLb:cc.Label = nHNode.getChildByName("lb").getComponent(cc.Label);
            let sibling = index + 1;
            nBLb.string = sibling.toString();
            nHLb.string = sibling.toString();
            if(this.pressNums.indexOf(sibling) > -1){
                nBNode.active = true;
                nHNode.active = false;
            }else{
                nBNode.active = false;
                nHNode.active = true;
            }
        });
    }

    // 按下号码按钮
    onBtnNumBtn(e:cc.Event.EventTouch){
        if(this.isBuy){
            O1HD.getModules().uiControlModule.showMessageBox("已经购买了！！！");
            return;
        }
        let node:cc.Node = e.target;
        let sibling:number = node.getSiblingIndex() + 1;
        let siblingIndex:number = this.pressNums.indexOf(sibling);
        if(siblingIndex > -1){
            // 从选择的数组中删除该按钮 并更新选择的号码
            this.pressNums.splice(siblingIndex,1);
            this.updateBtns();
            this.updateSelectLayout();
        }else if(this.pressNums.length >= 5){
            //
            O1HD.getModules().uiControlModule.showMessageBox("号码选满了");
        }else{
            //
            this.pressNums.push(sibling);
            this.updateBtns();
            this.updateSelectLayout();
        }
    }

    updateSelectLayout(){
        this.selectLayout.children.forEach((n:cc.Node,index:number)=>{
            if(this.pressNums[index]!=null){
                n.active = true;
                let nBNode:cc.Node = n.getChildByName("ball_b");
                let nBLb:cc.Label = nBNode.getChildByName("lb").getComponent(cc.Label);
                nBLb.string = this.pressNums[index].toString();
            }else{
                n.active = false;
            }
        });
    }

    onBtnBuy(){
        if(this.isBuy){
            O1HD.getModules().uiControlModule.showMessageBox("今日已购买，请等待开奖");
            return;
        }

        if(this.pressNums.length < 5){
            O1HD.getModules().uiControlModule.showMessageBox("需要选五个号码");
            return;
        }

        this.isBuy = true;
        if(O1HD.getServices().userSrv.getCoins() < this.lotteryPrice){
            O1HD.getModules().uiControlModule.showMessageBox("钱不够");
            NormalGameManager._instance.openBankPage();
            return;
        }

        let date = this.manager.getGameData().lotteryMachineData;
        date.meSelectAry = this.pressNums.concat();
        this.generateReward();
        date.buyDay = this.manager.getCurrentDay();
        this.manager.writeGameData();
        this.machineAni.playAnimation("animation").start(true);
        // this.openReward();
        O1HD.getModules().uiControlModule.showMessageBox("购买成功！明日开奖！");
    }

    // 普通中奖的中奖概率  分别对应为 一等奖 二等奖 三等奖 四等奖 五等奖 鼓励奖 未中奖
    normalRewardWeight:number[] = [60,21,16,1.5,0.4,0.07,0.01];

    // 金蛋中奖概率  分别对应为 未中奖 1金球 2金球 3金球 4金球 5金球
    goldEggWeight:number[] = [99.948,0.5,0.011,0.005,0.003,0.001];

    // // 彩蛋号码
    // fiveAry:number[][] = [
    //     [1,10,11,21,12],
    // ]

    // fourAry:number[][] = [
    //     [20,23,2,1,22]
    // ]

    // threeAry:number[][] =[
    //     [16,6,18,8,20]
    // ]

    // 购买完成生成中奖
    generateReward(){
        let normalIndex:number = data_control.getRandIPosByWeights(this.normalRewardWeight);
        // console.log(normalIndex,"???????怎么hi是")
        switch(normalIndex){
            case 0:
            case 1:{
                this.setNormalAry(0);
                if(normalIndex == 1){
                    this.manager.getGameData().lotteryMachineData.isConsolationPrize = true;
                }
                break;
            }
            default:{
                this.setNormalAry(normalIndex - 1);
                break;
            }
        }

        // this.setNormalAry(normalIndex);

        let isInAry = (nary:number[],iAry:number[][])=>{
            let manager = NormalGameManager._instance;
            for(let i =0;i<iAry.length;i++){
                let a = iAry[i];
                if(nary.toString() == a.toString() && !manager.getGameData().ariseLotteryNumbers.includes(a.toString())){
                    manager.getGameData().ariseLotteryNumbers.push(a.toString());
                    manager.writeGameData();
                    return true;
                }
            }
            return false;
        }

        let isFive:boolean = isInAry(this.pressNums,gameConfig.LOTTERY_FIVE_ARY);
        let isFour:boolean = isInAry(this.pressNums,gameConfig.LOTTERY_FOUR_ARY);
        let isThree:boolean = isInAry(this.pressNums,gameConfig.LOTTERY_THREE_ARY);

        if(isFive){
            this.setGoldAry(5);
        }else if(isFour){
            this.setGoldAry(4);
        }else if(isThree){
            this.setGoldAry(3);
        }else{
            let goldIndex:number = data_control.getRandIPosByWeights(this.goldEggWeight);
            this.setGoldAry(goldIndex);
        }

        console.log(this.manager.getGameData().lotteryMachineData,"双色球");
    }

    setGoldAry(goldNum:number){
        let ary = this.rewardNums.concat();
        let randAry = data_control.randomSortArray(ary);
        while(randAry.length > goldNum){
            randAry.pop();
        }
        randAry = data_control.randomSortArray(randAry);
        this.manager.getGameData().lotteryMachineData.goldAry = randAry.concat();
    }

    setNormalAry(normalNum:number){
        let ary = this.pressNums.concat();
        let randAry:number[] = data_control.randomSortArray(ary);
        while(randAry.length > normalNum){
            randAry.pop();
        }

        while(randAry.length < 5){
            let rand = Math.floor(Math.random() * this.numLayout.childrenCount) + 1;
            if(!this.pressNums.includes(rand) && !randAry.includes(rand)){
                randAry.push(rand);
            }
        }
        this.rewardNums = randAry.concat();
        randAry = data_control.randomSortArray(randAry);
        this.manager.getGameData().lotteryMachineData.winAry = randAry.concat();

    }

    layoutVec:cc.Vec2 = cc.v2(460,0);

    //开奖
    async openReward(){
        this.machineAni.playAnimation("animation").start(true);
        for(let i = 0;i<this.rewardNums.length;i++){
            await new Promise<void>(resolve=>{
                let ball = cc.instantiate(this.ballNode);
                    let num = this.rewardNums[i];
                    let goldAry = this.manager.getGameData().lotteryMachineData.goldAry;

                    let j_g = ball.getChildByName("ball_j_g");
                    let j_z = ball.getChildByName("ball_j_z");

                    let b_g = ball.getChildByName("ball_b_g");
                    let b_z = ball.getChildByName("ball_b_z");

                    let jLb:cc.Label = j_z.getChildByName("lb").getComponent(cc.Label);
                    let bLb:cc.Label = b_z.getChildByName("lb").getComponent(cc.Label);

                    jLb.string = num.toString();
                    bLb.string = num.toString();

                    j_g.active = false;
                    j_z.active = false;
                    b_g.active = false;
                    b_z.active = false;

                    if(goldAry.includes(num)){
                        j_g.active = true;
                    }else{
                        b_g.active = true;
                    }
                    ball.setParent(this.ballPoint);
                    ball.setPosition(cc.v2(0,0));
                    cc.tween(ball).to(1,{angle:-720}).start();
                    this.scheduleOnce(()=>{
                        ball.setParent(this.lotteryLayout);
                        ball.setPosition(this.layoutVec);
                        let targetx:number = i * ball.width + 29;
                        if(goldAry.includes(num)){
                            j_g.active = false;
                            j_z.active = true;
                        }else{
                            b_g.active = false;
                            b_z.active = true;
                        }

                        let time = (this.layoutVec.x - targetx) / 200;
                        cc.tween(ball).to(time,{x:targetx,angle: (Math.floor((5 - i) / 2)) * 360}).start();
                        this.scheduleOnce(resolve,time);
                    },1);
                this.ballAni.playAnimation("animation").start(false);
            });
        }
        this.openClean();
    }

    // 打开结算
    openClean(){
        this.resultNode.active = true;
    }

    onBtnBack(){
        this.node.destroy();
        this.node.removeFromParent();
    }

    resultEnd(){
        this.machineAni.animation = null;
        this.pressNums = [];
        this.rewardNums = [];
        this.updateBtns();
        this.updateSelectLayout();
        this.isBuy = false;
        this.lotteryLayout.destroyAllChildren();
        this.lotteryLayout.removeAllChildren();
    }

}
